import { render, staticRenderFns } from "./add-device2.vue?vue&type=template&id=47e6a54a&scoped=true&"
import script from "./add-device2.js?vue&type=script&lang=js&"
export * from "./add-device2.js?vue&type=script&lang=js&"
import style0 from "./add-device2.css?vue&type=style&index=0&id=47e6a54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6a54a",
  null
  
)

export default component.exports